
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[companySlug]",
      function () {
        return require("private-next-pages/[companySlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[companySlug]"])
      });
    }
  